// export const knownChainIds = [...NETWORKS_BY_ID.keys()];

import config from '#/config';
import { getCurrentStateChainConfig } from '#/config/configUtils';
import { NETWORKS_BY_ID_OVERRIDE } from '#/config/constants';
import { configProduction, configSandbox } from '#/config/environments';

import type { ChainConfig } from '#/config/configType';

export const getNetworkChainName = (chainId: number | bigint): string => {
  /** Generate known network names for Prod and Sandbox chains */
  const knownConfigNetworkNames = Object.values(configSandbox.chains)
    .map(chain => [chain.chainId, chain.chainNetwork] as const)
    .concat(
      Object.values(configProduction.chains).map(chain => [
        chain.chainId,
        chain.chainNetwork,
      ])
    )
    .reduce(
      (map, chain) => {
        map[chain[0]] = chain[1];
        return map;
      },
      {} as { [chainId: number]: string }
    );
  const networkById = {
    ...NETWORKS_BY_ID_OVERRIDE,
    // Include all values from main configuration
    ...knownConfigNetworkNames,
  };

  return networkById[Number(chainId)] || `Chain id ${chainId}`;
};

let enforcedChainId: number | undefined = undefined;

/**
 * Only use for depositing from other chains (or legacy migration).
 * Default enforced chain is KATANA after calling clearGlobalEnforcedChainId.
 */
export const globalEnforceChainId = (chainId?: number) => {
  enforcedChainId = chainId;
};

export const clearGlobalEnforcedChainId = () => {
  enforcedChainId = undefined;
};

export const getGlobalEnforcedChain = (): ChainConfig | undefined => {
  // TODO: store chainCode instead in enforcedChainId ?
  return Object.values(config.chains).find(
    chain => chain.chainId === enforcedChainId
  );
};

export const throwOnDifferentThanCurrentChainId = (
  walletChainId: number | bigint
) => {
  // if (!enforcedChainId) {
  //   // TODO: no longer true as typedData require chain !
  //   // For most app functionality we only have to sign messages
  //   // which are not chain dependent - TYPED DATA REQUIRE NETWORK
  //   return;
  // }
  if (!walletChainId || Number(walletChainId) <= 0) {
    throw new Error('Cannot detect wallet chain ID (network)');
  }
  // TODO: verify this is correct approach ! eg on Legacy balances pages (migrations)
  const currentChainId =
    enforcedChainId || getCurrentStateChainConfig().chainId;

  console.log({ walletChainId, currentChainId });

  if (String(walletChainId) !== String(currentChainId)) {
    console.log('Wallet chain ID is', walletChainId);
    throw new Error(
      `Please change the network to ${getNetworkChainName(
        currentChainId
      )} to proceed.`
      // `Your wallet is on the wrong chain. IDEX is running on "${getNetworkChainName(
      //   currentChainId
      // )}" and your wallet is using "${getNetworkChainName(walletChainId)}".`
    );
  }
};
